import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastProvider } from "./toast";
import { FirebaseAuthProvider } from "./auth";
import ErrorBoundary from "./components/ErrorBoundary";

// Handle unhandled promise rejections from Firebase Analytics
// This prevents Analytics errors from crashing the app
window.addEventListener("unhandledrejection", (event) => {
  if (
    event.reason &&
    typeof event.reason === "object" &&
    event.reason.message &&
    (event.reason.message.includes("Analytics") ||
      event.reason.message.includes("analytics/config-fetch-failed") ||
      event.reason.message.includes("API key not valid"))
  ) {
    // Suppress Firebase Analytics API key errors - Analytics is optional
    console.warn(
      "[Firebase Analytics] Analytics initialization failed (non-critical):",
      event.reason.message
    );
    event.preventDefault(); // Prevent the error from being logged as an unhandled rejection
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <FirebaseAuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </FirebaseAuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
